require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-organizaciones-de-sociedad-civil-denuncian-la-respuesta.json") })
        }
      }, "path---es-mx-update-organizaciones-de-sociedad-civil-denuncian-la-respuesta");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-organizaciones-de-sociedad-civil-denuncian-la-respuesta!./.cache/json/es-mx-update-organizaciones-de-sociedad-civil-denuncian-la-respuesta.json
// module id = 935
// module chunks = 231608221292675